package com.essntl.core.settings.ui

sealed interface AllowedCurrenciesNavigation {
    data object AddCurrency : AllowedCurrenciesNavigation
}